import React, { useState, useEffect } from 'react';
import './App.css';

// Reusable Discorectangle Button Component
const DiscoButton = ({ text, onClick }) => (
  <button className="disco-btn" onClick={onClick}>
    {text}
  </button>
);

// A funkadelic card component shaped like a Discorectangle
const DiscoCard = ({ title, content }) => (
  <div className="disco-card">
    <div className="disco-card-inner">
      <h2>{title}</h2>
      <p>{content}</p>
    </div>
  </div>
);

function App() {
  const [bpm, setBpm] = useState(120);
  const [colorIndex, setColorIndex] = useState(0);

  // Cycle through neon colors automatically
  useEffect(() => {
    const interval = setInterval(() => {
      setColorIndex((prev) => (prev + 1) % 4);
    }, 60000 / bpm); // Beat matches BPM
    return () => clearInterval(interval);
  }, [bpm]);

  const colors = ['#ff00ff', '#00ffff', '#ffff00', '#ff0055'];
  
  return (
    <div className="app-container" style={{ '--active-color': colors[colorIndex] }}>
      <header className="hero-section">
        <h1 className="title">Happy Birthday Evan!!!</h1>
        <p className="subtitle">you now own a website!!!</p>
        
        {/* The main visual representation of a Discorectangle */}
        <div className="visual-stage">
          <div className="giant-discorectangle pulsing">
            <span>GET DOWN</span>
          </div>
        </div>
      </header>

      <main className="content-grid">
        <DiscoCard 
          title="The Shape" 
          content="Technically known as a 'Stadium' or 'Obround', we prefer the term Discorectangle. It is 50% business, 50% circle, 100% funky." 
        />
        <DiscoCard 
          title="The Vibe" 
          content="Infinite loops, neon gradients, and CSS keyframes. This layout refuses to be square." 
        />
        
        <div className="controls-section">
          <h3>Groove Control</h3>
          <p>Current BPM: {bpm}</p>
          <div className="button-group">
            <DiscoButton text="Slower" onClick={() => setBpm(Math.max(60, bpm - 10))} />
            <DiscoButton text="Faster" onClick={() => setBpm(Math.min(200, bpm + 10))} />
          </div>
        </div>
      </main>

      <footer className="footer">
        <p>© 2025 Discorectangle heavy industries. Keep on turning.</p>
      </footer>
    </div>
  );
}

export default App;